import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../../styles/support/supportButton.scss";

class SupportButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      copied: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname && this.state.open) {
      this.setState({ open: false, copied: false });
    }
  }

  shouldShowSupport = () => {
    const token = localStorage.getItem("token");
    const path = this.props.location.pathname.toLowerCase();
    return !!token && path !== "/login";
  };

  toggleSupport = () => {
    this.setState((state) => ({
      open: !state.open,
      copied: false,
    }));
  };

  closeSupport = () => {
    this.setState({ open: false, copied: false });
  };

  copyEmailToClipboard = async () => {
    const email = "support@visiontrak.com.au";

    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(email);
      return;
    }

    const textArea = document.createElement("textarea");
    textArea.value = email;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "absolute";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
  };

  copyEmail = async () => {
    try {
      await this.copyEmailToClipboard();

      this.setState({ copied: true });
    } catch (error) {
      this.setState({ copied: false });
    }
  };

  openEmailSupport = async () => {
    await this.copyEmail();
    window.location.href = "mailto:support@visiontrak.com.au";
  };

  render() {
    if (!this.shouldShowSupport()) {
      return null;
    }

    return (
      <div className="supportLauncher">
        {this.state.open && (
          <div className="supportPanel" role="dialog" aria-modal="false" aria-labelledby="supportPanelTitle">
            <div className="supportPanelHeader">
              <div>
                <span>Need help?</span>
                <h2 id="supportPanelTitle">VisionTrak Support</h2>
              </div>
              <button className="supportCloseButton" type="button" onClick={this.closeSupport} aria-label="Close support details">
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>

            <div className="supportQuickActions">
              <a className="supportAction primary" href="tel:1800872537">
                <i className="fa fa-phone" aria-hidden="true" />
                <span>1800 872 537</span>
              </a>
              <button className="supportAction" type="button" onClick={this.openEmailSupport}>
                <i className="fa fa-envelope" aria-hidden="true" />
                <span>{this.state.copied ? "Email copied" : "Email support"}</span>
              </button>
            </div>

            <div className="supportDetails">
              <div className="supportDetailRow">
                <i className="fa fa-building-o" aria-hidden="true" />
                <div>
                  <strong>VisionTrak Rentals Pty Ltd</strong>
                  <span>Suite 5, 72A Doncaster Road, Balwyn North VIC 3104</span>
                </div>
              </div>
              <div className="supportDetailRow">
                <i className="fa fa-archive" aria-hidden="true" />
                <div>
                  <strong>Postal address</strong>
                  <span>PO BOX 233, Balwyn North VIC 3104</span>
                </div>
              </div>
              <div className="supportContactGrid">
                <a className="supportContactLine" href="tel:0399991222">
                  <span className="supportContactLabel">T:</span>
                  <span>03 9999 1222</span>
                </a>
                <button className="supportContactLine" type="button" onClick={this.openEmailSupport}>
                  <span className="supportContactLabel">E:</span>
                  <span>support@visiontrak.com.au</span>
                </button>
                <a className="supportWebsiteLink" href="https://www.visiontrak.com.au/" target="_blank" rel="noopener noreferrer">
                  <span className="supportContactLabel">W:</span>
                  <span>visiontrak.com.au</span>
                </a>
              </div>
            </div>

            <div className="supportFooter">
              <button className="supportCopyButton" type="button" onClick={this.copyEmail}>
                <i className={this.state.copied ? "fa fa-check" : "fa fa-copy"} aria-hidden="true" />
                <span>{this.state.copied ? "Email copied" : "Copy support email"}</span>
              </button>
              <span>Include your account, asset, and a screenshot where possible.</span>
            </div>
          </div>
        )}

        <button
          className={this.state.open ? "supportFloatingButton active" : "supportFloatingButton"}
          type="button"
          onClick={this.toggleSupport}
          aria-expanded={this.state.open}
          aria-label="Open VisionTrak support details"
          title="Support"
        >
          <svg className="supportHeadsetIcon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path className="supportHeadband" d="M4.2 13.1C4.2 6.8 7.6 2.9 12 2.9s7.8 3.9 7.8 10.2" />
            <path className="supportEarCup supportEarCupLeft" d="M5.7 11.1H4.6c-1 0-1.8.8-1.8 1.8v2.9c0 1.5 1.2 2.7 2.7 2.7h.2c.8 0 1.4-.6 1.4-1.4v-4.6c0-.8-.6-1.4-1.4-1.4Z" />
            <path className="supportEarCup supportEarCupRight" d="M18.3 11.1h1.1c1 0 1.8.8 1.8 1.8v2.9c0 1.5-1.2 2.7-2.7 2.7h-.2c-.8 0-1.4-.6-1.4-1.4v-4.6c0-.8.6-1.4 1.4-1.4Z" />
            <path className="supportBoom" d="M18.8 17.5c-.45 1.85-1.85 3.15-4.15 3.9" />
            <path className="supportMic" d="M11.45 20.65 14 19.8c.7-.23 1.45.15 1.68.85.23.69-.15 1.44-.84 1.67l-2.55.85c-.7.23-1.45-.15-1.68-.85-.23-.69.15-1.44.84-1.67Z" />
          </svg>
          <span>Support</span>
        </button>
      </div>
    );
  }
}

export default withRouter(SupportButton);
